import { ChangeEvent } from 'react'

const handleValueChange = (
  { target }: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  callback: Function
) => callback(target.value)

export { handleValueChange }
